<template>
  <CModal :show.sync="show" centered :title="$pgettext('downloader.email_modal', 'Send download link')">
    <template v-if="isBlocked">
      <CAlert color="danger" class="text-center">
        <b><translate translate-context="downloader.email_modal">Download not available</translate></b><br>
        <translate translate-context="downloader.email_modal"
                   :translate-params="{limit: limits.emailLimit}">
          Cannot download more than %{limit} files
        </translate>
      </CAlert>
    </template>
    <template v-else>
      <p class="text-muted">
        <translate translate-context="downloader.email_modal"
                   :translate-params="{count: request.count}">
          You are downloading %{count} files. The download link will be sent to your email.
        </translate>
      </p>
      <CInput
          v-model="email"
          :placeholder="$pgettext('downloader.email_modal', 'E-Mail')"
          type="email"
      />
    </template>
    <template #footer>
      <CButton color="secondary" @click="onCancel">
        <translate translate-context="downloader.email_modal">Cancel</translate>
      </CButton>
      <CButton v-if="!isBlocked" color="primary" @click="onSubmit" :disabled="!isValidEmail">
        <translate translate-context="downloader.email_modal">Send</translate>
      </CButton>
    </template>
  </CModal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'DownloadEmailModal',
  data() {
    return {
      show: false,
      email: ''
    }
  },
  computed: {
    ...mapGetters('downloader', ['emailRequest', 'limits']),
    ...mapGetters('login', { defaultEmail: 'email' }),
    request() {
      return this.emailRequest || {}
    },
    isBlocked() {
      return this.request.blocked
    },
    isValidEmail() {
      return this.email && this.email.includes('@')
    }
  },
  watch: {
    emailRequest: {
      handler(request) {
        if (request) {
          this.email = this.defaultEmail || ''
          this.show = true
        }
      },
      immediate: true
    },
    show(val) {
      if (!val && this.emailRequest) {
        // Modal closed without submitting - cancel
        this.onCancel()
      }
    }
  },
  methods: {
    ...mapMutations('downloader', ['resolveEmailRequest', 'rejectEmailRequest']),
    onSubmit() {
      if (this.isValidEmail) {
        this.resolveEmailRequest(this.email)
        this.show = false
      }
    },
    onCancel() {
      this.rejectEmailRequest()
      this.show = false
    }
  }
}
</script>
